import { Checkbox, Row } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import React, { useMemo } from "react";
import { ITrainingCourse } from "src/@types/ImpiricaPlatformApi";
import _ from "lodash";

interface IProps {
	options?: ITrainingCourse[];
	existingCourses?: number[];
	onChange?: (courses: number[]) => void;
}

const OrganizationUsersTrainingCourses: React.FC<IProps> = React.forwardRef<
	HTMLDivElement,
	IProps
>(({ options, existingCourses, onChange }, ref) => {
	const _onChange = (e: CheckboxValueType[]) => {
		if (onChange) {
			onChange(e as number[]);
		}
	};

	const checkedCourses = useMemo(() => {
		// add the id of any training course with autoEnrollAll to existingCourses and return the distinct list
		return _.uniq(
			_.concat(
				existingCourses || [],

				_.filter(options, (o) => o.autoEnrollAll).map((o) => o.id)
			)
		);
	}, [existingCourses, options]);

	return (
		<div ref={ref} data-testid="course-list">
			<Checkbox.Group onChange={_onChange} value={checkedCourses}>
				{options && options.length > 0 ? (
					options.map((item) => (
						<Row key={item.id}>
							<Checkbox
								data-testid="course-list-item"
								value={item.id}
								disabled={item.autoEnrollAll}
							>
								{`${item.title}`}
							</Checkbox>
						</Row>
					))
				) : (
					<p>There are no training courses available</p>
				)}
			</Checkbox.Group>
		</div>
	);
});

export default OrganizationUsersTrainingCourses;
